import { call, put, take, select } from "redux-saga/effects";
import {
  REQUEST_ERROR,
  REQUESTING,
  REQUEST_SUCCESS
} from "../types/request.types";
import axios from "axios";
import dayjs from "dayjs";

const urlAPI = "/api";

export async function fetcher(
  method = "GET",
  route = "carte",
  body,
  header,
  changeUrlApi = false
) {
  try {
    const result = await axios({
      method: method,
      headers: {
        "Content-Type": "application/json",
        authorization: header
      },
      url: changeUrlApi ? route : `${urlAPI}/${route}`,
      data: body
    });
    return result;
  } catch (err) {
    return err;
  }
}

export function* requestHandler(method, route, body, header) {
  try {
    const requestObj = {
      method: method,
      time: dayjs().format("DD/MM/YYYY HH:mm"),
    };
    yield put({ type: REQUESTING, request: requestObj });
    const result = yield call(fetcher, method, route, body, header);
    const successFullRequest = {
      ...requestObj
    };
    yield put({ type: REQUEST_SUCCESS, requestSuccess: successFullRequest });
    return result;
  } catch (err) {
    yield put({
      type: REQUEST_ERROR,
      error: err
    });

    return { result: false };
  }
}
